// extracted by mini-css-extract-plugin
export default {"content":"Board_dev_content__eN0up","ref":"Board_dev_ref__1G0U8","board-container":"Board_dev_board-container__wZJoc","content2":"Board_dev_content2__Rl-9R"};